import React, {Component} from 'react'
import {AccountBalanceWallet, AccountCircle, Add, AdminPanelSettings, Assessment, CellTower, Code, Contacts, CurrencyRupee, Dashboard as DashboardIcon,
  Email, ExpandLess, ExpandMore, Drafts, Group, Groups, MarkEmailRead, MarkEmailUnread, Schedule, Settings, Subtitles}
  from '@mui/icons-material'
import {Box, Collapse, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar} from '@mui/material'
import {blue} from '@mui/material/colors';
import {styled} from '@mui/material/styles';
import {withRouter} from 'react-router-dom'

import {GAEventTracker} from '../../lib/googleAnalytics'
import {isImpersonating} from '../../lib/impersonation'
import {isAdminPanelRole, isAdminToolRole, isSupportTierRole} from '../../auth/roles'
import {canViewNotifications} from '../../lib/notifications'
import {routeCodes} from '../../views/App'
import {OfferBannerSpacer} from '../OfferBanner'

const NAV = [
  {type: 'DASHBOARD', text: 'Dashboard', icon: DashboardIcon},
  {type: 'SMS', text: 'Send SMS', icon: Email},
  {type: 'CUSTOMIZE_SMS', text: 'Customize SMS', icon: MarkEmailUnread},
  {type: 'TEMPLATE', text: 'Templates/Headers', icon: Settings},
  {type: 'CONTACTS', text: 'Manage Contacts', icon: Contacts}
]
const SEC_NAV = [
  {type: 'BLOCKED_CONTACTS', text: 'Manage Blocked Numbers', icon: Contacts},
  // {type: 'SCHEDULED_SMS', text: 'Scheduled SMS', icon: Schedule},
  {type: 'SMS_HISTORY', text: 'SMS Reports', icon: Assessment},
  {type: 'ALL_SMS_HISTORY', text: 'Sent Messages', icon: MarkEmailRead},
  {type: 'CREDIT_HISTORY', text: 'Credit History', icon: CurrencyRupee}
]
const drawerWidth = 264

const CustomListItemButton = styled(ListItemButton)({
  '&.Mui-selected': {
    borderRight: `1px solid ${blue[700]}`
  }
});

class MenuDrawer extends Component {
  constructor(props) {
    super(props)
    const {open, type} = props
    this.state = {
      openDrawer: open,
      showGroup: !!(type === 'GROUP' || type === 'CREATE_GROUP'),
      groupOpen: false
    };
  }
  // Derived from props every render so the Groups submenu reflects the
  // current address book (extraNav can be empty on first paint, populated
  // after getContactGroup() writes groupData to localStorage).
  buildMenuBar() {
    const {extraNav = []} = this.props
    const bar = []
    for (const nav of extraNav) {
      bar.push({type: 'GROUP', primaryText: nav.name, key: `GROUP${ nav.id }`, id: nav.id, icon: 'group'})
    }
    return bar
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.openDrawer) {
      this.setState({openDrawer: nextProps.open})
    }
  }
  navRoute = (e, route, id) => {
    e.stopPropagation()
    if (id) {
      this.props.history.push(route.replace(':groupId', id))
    } else {
      this.props.history.push(route)
    }
  }
  toggleGroup = (e) => {
    e.stopPropagation()
    const {showGroup, groupOpen} = this.state
    this.setState({showGroup: !showGroup, groupOpen: !groupOpen})
    GAEventTracker({category: 'Group-Toggle', action: 'Click'})
  }
  render() {
    let {type, role} = this.props
    const {showGroup, groupOpen, openDrawer} = this.state
    const menuBar = this.buildMenuBar()
    // While impersonating a tenant user we hide the platform-admin nav
    // items even though baseConfiguration.role still resolves to the
    // operator's role — the impersonated session shouldn't expose
    // cross-tenant admin tooling. The route guard in AuthRoute enforces
    // the same thing for direct URL access.
    const impersonating = isImpersonating()
    if (type === 'GROUP') {
      const gId = this.props.history.location.pathname.split('/group/')[1];
      type = `GROUP${ gId }`
    }
    return (
      openDrawer ?
        <Drawer          
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {width: drawerWidth, boxSizing: 'border-box'}
          }}
          className={window.isMobile() ? 'iphone-touch-scroll' : ''}>
          <Toolbar />
          <OfferBannerSpacer />
          <Box sx={{overflow: 'auto'}}>
            <List>
              {!impersonating && isAdminPanelRole(role) &&
                <ListItem key="ADMIN_PANEL" disablePadding>
                  <CustomListItemButton selected={type === 'ADMIN_PANEL'} onClick={(e) => this.navRoute(e, routeCodes.ADMIN_PANEL)}>
                    <ListItemIcon sx={{minWidth: 36}}>
                      <AdminPanelSettings {...(type === 'ADMIN_PANEL' ? {color:"primary"} : {})} />
                    </ListItemIcon>
                    <ListItemText primary="Admin Panel" {...(type === 'ADMIN_PANEL' ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
                  </CustomListItemButton>
                </ListItem>}
              {!impersonating && isAdminToolRole(role) &&
                <ListItem key="MANAGE_OPERATORS" disablePadding>
                  <CustomListItemButton selected={type === 'MANAGE_OPERATORS'} onClick={(e) => this.navRoute(e, routeCodes.MANAGE_OPERATORS)}>
                    <ListItemIcon sx={{minWidth: 36}}>
                      <CellTower {...(type === 'MANAGE_OPERATORS' ? {color:"primary"} : {})} />
                    </ListItemIcon>
                    <ListItemText primary="Manage Operators" {...(type === 'MANAGE_OPERATORS' ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
                  </CustomListItemButton>
                </ListItem>}
              {/* Ops Dashboard moved to a tab inside Dashboard for admin users —
                  see src/views/NewDashboard/index.jsx. /ops-dashboard stays
                  as a route alias that pre-selects that tab so bookmarks
                  continue to work. */}
              {!impersonating && isAdminToolRole(role) &&
                <ListItem key="RATE_LIMITS" disablePadding>
                  <CustomListItemButton selected={type === 'RATE_LIMITS'} onClick={(e) => this.navRoute(e, routeCodes.RATE_LIMITS)}>
                    <ListItemIcon sx={{minWidth: 36}}>
                      <Subtitles {...(type === 'RATE_LIMITS' ? {color:"primary"} : {})} />
                    </ListItemIcon>
                    <ListItemText primary="Rate Limits" {...(type === 'RATE_LIMITS' ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
                  </CustomListItemButton>
                </ListItem>}
              {!impersonating && isAdminPanelRole(role) &&
                <ListItem key="BALANCE_NOTIFICATIONS" disablePadding>
                  <CustomListItemButton selected={type === 'BALANCE_NOTIFICATIONS'} onClick={(e) => this.navRoute(e, routeCodes.BALANCE_NOTIFICATIONS)}>
                    <ListItemIcon sx={{minWidth: 36}}>
                      <AccountBalanceWallet {...(type === 'BALANCE_NOTIFICATIONS' ? {color:"primary"} : {})} />
                    </ListItemIcon>
                    <ListItemText primary="Balance Notifications" {...(type === 'BALANCE_NOTIFICATIONS' ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
                  </CustomListItemButton>
                </ListItem>}
              {!impersonating && canViewNotifications(role) &&
                <ListItem key="EMAIL_TEMPLATES" disablePadding>
                  <CustomListItemButton selected={type === 'EMAIL_TEMPLATES'} onClick={(e) => this.navRoute(e, routeCodes.EMAIL_TEMPLATES)}>
                    <ListItemIcon sx={{minWidth: 36}}>
                      <Drafts {...(type === 'EMAIL_TEMPLATES' ? {color:"primary"} : {})} />
                    </ListItemIcon>
                    <ListItemText primary="Email Templates" {...(type === 'EMAIL_TEMPLATES' ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
                  </CustomListItemButton>
                </ListItem>}
              {NAV.filter((el) => !(isSupportTierRole(role) && el.type === 'CONTACTS')).map(el =>
                <ListItem key={el.type} disablePadding>
                  <CustomListItemButton selected={type === el.type} onClick={(e) => this.navRoute(e, routeCodes[el.type])}>
                    <ListItemIcon sx={{minWidth: 36}}>
                      <el.icon {...(type === el.type ? {color:"primary"} : {})} />
                    </ListItemIcon>
                    <ListItemText primary={el.text} {...(type === el.type ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
                  </CustomListItemButton>
                </ListItem>
              )}
            </List>
            <Divider />
            {!isSupportTierRole(role) && <>
            <ListItem key="CREATE_GROUP" disablePadding>
              <CustomListItemButton selected={type === 'CREATE_GROUP'} onClick={(e) => this.navRoute(e, routeCodes.CREATE_GROUP)}>
                <ListItemIcon sx={{minWidth: 36}}>
                  <Add {...(type === 'CREATE_GROUP' ? {color:"primary"} : {})} />
                </ListItemIcon>
                <ListItemText primary="Create Group" {...(type === 'CREATE_GROUP' ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
              </CustomListItemButton>
            </ListItem>
            <Divider />
            <ListItem key="GROUPS" disablePadding>
              <CustomListItemButton onClick={this.toggleGroup}>
                <ListItemIcon sx={{minWidth: 36}}>
                  <Groups />
                </ListItemIcon>
                <ListItemText primary="Groups" />
                {groupOpen ? <ExpandLess /> : <ExpandMore />}
              </CustomListItemButton>
            </ListItem>
            <Collapse in={showGroup} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {menuBar.map((data) => (
                  <ListItem key={data.key} disablePadding sx={{pl: 3}}>
                    <CustomListItemButton selected={type === data.key} onClick={(e) => this.navRoute(e, routeCodes[data.type], data.id)}>
                      <ListItemIcon sx={{minWidth: 36}}>
                        <Group {...(type === data.key ? {color:"primary"} : {})} />
                      </ListItemIcon>
                      <ListItemText primary={data.primaryText} {...(type === data.key ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
                    </CustomListItemButton>
                  </ListItem>
                ))}
              </List>
            </Collapse>
            </>}
            <Divider />
            {SEC_NAV.map(el =>
              <ListItem key={el.type} disablePadding>
                <CustomListItemButton selected={type === el.type} onClick={(e) => this.navRoute(e, routeCodes[el.type])}>
                  <ListItemIcon sx={{minWidth: 36}}>
                    <el.icon {...(type === el.type ? {color:"primary"} : {})} />
                  </ListItemIcon>
                  <ListItemText primary={el.text} {...(type === el.type ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
                </CustomListItemButton>
              </ListItem>
            )}
            <Divider />
            {/* Shown while impersonating too (2026-10-18) so support can read the
                customer's webhook config. The API Keys tab inside stays hidden
                while impersonating — credentials are not support's to see
                (enforced in DevelopersTool/index.jsx, not just here). */}
            <ListItem key="DEVELOPERS_TOOL" disablePadding>
              <CustomListItemButton selected={type === 'DEVELOPERS_TOOL'} onClick={(e) => this.navRoute(e, routeCodes.DEVELOPERS_TOOL)}>
                <ListItemIcon sx={{minWidth: 36}}>
                  <Code {...(type === 'DEVELOPERS_TOOL' ? {color:"primary"} : {})} />
                </ListItemIcon>
                <ListItemText primary="Developers Tool" {...(type === 'DEVELOPERS_TOOL' ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
              </CustomListItemButton>
            </ListItem>
            <ListItem key="MY_ACCOUNT" disablePadding>
              <CustomListItemButton selected={type === 'MY_ACCOUNT'} onClick={(e) => this.navRoute(e, routeCodes.MY_ACCOUNT)}>
                <ListItemIcon sx={{minWidth: 36}}>
                  <AccountCircle {...(type === 'MY_ACCOUNT' ? {color:"primary"} : {})} />
                </ListItemIcon>
                <ListItemText primary="My Account" {...(type === 'MY_ACCOUNT' ? {primaryTypographyProps: {color: "#1976d2"}} : {})} />
              </CustomListItemButton>
            </ListItem>
            <Divider />
          </Box>
        </Drawer>
        : null
    );
  }
}
export default withRouter(MenuDrawer)
